import { MoneyLinkException } from "@/shared/utils/custom-exception";
import { ApiClient } from "@/shared/services/api-client";
import { GetCrecaAggregateStatusRequestModel, GetCrecaAggregateStatusResponseModel } from "@/features/accounts/creca/services/crecaaggregate-status-model";

export class CrecaAggregateStatusApi {
/**
* アグリゲーション状態取得API
*/
    public getAggregateStatus = async (
        param: GetCrecaAggregateStatusRequestModel
    ): Promise<GetCrecaAggregateStatusResponseModel> => {
        // pythonのblueprintでは /aggregate/status
        const path = `/api/crecaaggregate/status`;

        const res = await ApiClient.instance.get<GetCrecaAggregateStatusResponseModel>({
            path: path,
            params: param as NonNullable<unknown>,
        });

        if (res.ok === false) {
            throw MoneyLinkException.fromServer({ response: res });
        }

        return res.body;
    };
}
